<div class="page">
    <div class="title">
        <button class="buttonBack" (click)="goBack()"><mat-icon>arrow_back</mat-icon></button>
        <div class="titleValue">{{ "issue.tracking.title" | transloco }}</div>
    </div>
    <div class="chat">
        <div class="mensajes" #mensajesContainer>
            <div [class]="seguimiento.author === 3005 ? 'right' : 'left'" *ngFor="let seguimiento of seguimientos">
                <div [class]="seguimiento?.author === 3005 ? 'mensajeSaliente' : 'mensajeEntrante'">
                    <div [innerHTML]="seguimiento.contents"></div>
                    <div *ngIf="seguimiento.adjuntos.length > 0" style="display: flex; gap: 0.5rem; flex-wrap: wrap;">
                        <ng-container *ngFor="let itemAdjunto of seguimiento.adjuntos">
                            <ng-container *ngIf="itemAdjunto.adjunto">
                                <button 
                                    class="adjunto-boton"
                                    (click)="descargarAdjunto(itemAdjunto.adjunto)"
                                    style="
                                        display: flex;
                                        align-items: center;
                                        justify-content: flex-start;
                                        width: 100%;
                                        border: none;
                                        background: #f8fafd;
                                        border-radius: 8px;
                                        padding: 10px 14px;
                                        margin-bottom: 8px;
                                        box-shadow: 0 1px 4px rgba(0,0,0,0.04);
                                        cursor: pointer;
                                        transition: background 0.2s;
                                    "
                                    [ngStyle]="{'background':'#f8fafd'}"
                                >
                                    <mat-icon style="font-size: 26px; color: #0a77ec;">{{ getIconFile(itemAdjunto.adjunto) }}</mat-icon>
                                    <span
                                        style="margin-left: 16px; font-size: 15px; font-weight: 500; flex: 1; text-align: left; color: #131d29; overflow-wrap: anywhere;"
                                    >
                                        {{ itemAdjunto.adjunto.filename }}
                                    </span>
                                </button>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="inputContainer">
            <div class="inputText">
                <textarea class="textarea" [(ngModel)]="textoSeguimiento" [placeholder]="'issue.tracking.messagePlaceholder' | transloco"></textarea>
                <div class="adjuntar-container">
                    <button class="adjuntar" (click)="toggleAdjuntarMenu()" title="Adjuntar archivo">
                        <mat-icon>attach_file</mat-icon>
                    </button>
                    <div class="adjuntar-menu" *ngIf="mostrarMenuAdjuntar">
                        <button class="menu-item" (click)="seleccionarArchivo()">
                            <mat-icon>folder_open</mat-icon>
                            <span>Adjuntar archivo</span>
                        </button>
                        <button class="menu-item" (click)="tomarFoto()">
                            <mat-icon>camera_alt</mat-icon>
                            <span>Tomar foto</span>
                        </button>
                    </div>
                </div>
                <input
                    #fileInput
                    type="file"
                    accept="image/*, video/*, .pdf, .doc, .docx"
                    (change)="onFileSelected($event)"
                    style="display: none"
                />
                <button class="enviar" [style]="!textoSeguimiento || textoSeguimiento === '' || loading ? 'opacity: 0.5' : ''" [disabled]="!textoSeguimiento || textoSeguimiento === '' || loading" (click)="crearNuevoSeguimiento()">
                    <span *ngIf="loading" class="spin">
                        <mat-icon>sync</mat-icon>
                    </span>
                    {{ "issue.tracking.send" | transloco }}</button>
            </div>
            
            <!-- Previsualización de archivos adjuntos -->
            <div class="archivosAdjuntos" *ngIf="archivosAdjuntos.length > 0">
                <div class="archivoItem" *ngFor="let archivo of archivosAdjuntos; let i = index">
                    <div class="archivoInfo">
                        <div class="archivoIcono">
                            <mat-icon>{{ obtenerIconoArchivo(archivo) }}</mat-icon>
                        </div>
                        <div class="archivoDetalles">
                            <span class="nombreArchivo">{{ archivo.name }}</span>
                            <span class="tamañoArchivo">{{ formatearTamano(archivo.size) }}</span>
                        </div>
                    </div>
                    <button class="eliminarArchivo" (click)="eliminarArchivo(i)" title="Eliminar archivo">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>